import { render, staticRenderFns } from "./Internamiento.vue?vue&type=template&id=7c04dea5&"
import script from "./Internamiento.vue?vue&type=script&lang=js&"
export * from "./Internamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports